import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextArea, Select, Button } from 'loyal-react'

import Modal from 'react-awesome-modal'
import { connect } from 'react-redux'

class ModalReportStore extends Component {
  constructor () {
    super()
    this.state = {
      complainId: null,
      complainComment: null,
      buttonDisabled: false
    }
  }
  selectComplain (e) {
    this.setState({ complainId: e.idComplain || null })
  }
  commentComplain (e) {
    this.setState({ complainComment: (e.target && e.target.value) || null })
  }
  onSubmit = () => {
    this.setState({ buttonDisabled: true })

    this.props.toReport(this.props.email && this.props.email.value, this.state.complainId, this.state.complainComment).then(result => {
      if (result.data.message === 'Reclamação criada com sucesso, foi enviado um email com todas as informações sobre seu chamado.') {
        this.setState({ buttonDisabled: false })
      } else {
        this.setState({ buttonDisabled: false })
      }
    })
  }
  render () {
    return (
      <div className=' modal-marker'>
        <Modal width='100%' height='100%' effect='fadeInUp' visible={this.props.show}>
          <div className='container h-100'>
            <div className='row align-items-center h-100'>
              <div className='modal-report col-auto mx-auto bg-white radius '>
                <div className='row'>
                  <div className='col-12 py-2 px-2 border-bottom border-color-ui-3'>
                    <h2 className='py-half'>algum problema com este anúncio?</h2>
                  </div>
                  <div className='col-12 py-2 px-2'>
                    <div className='row align-items-center'>
                      <div className='col-auto'>
                        <i className='icon icon_help color-brand-1' />
                      </div>
                      <div className='col'>
                        <p>Preencha os campos abaixo para fazer a denúncia.</p>
                      </div>
                    </div>
                  </div>
                  <div className='col-11 mx-auto'>
                    <div className='row'>
                      {
                        this.props.errorReportComplain ? (
                          <div className='col-12'>
                            <p className='txt-body-sm color-error'>Ocorreu um erro! Não foi possível salvar.</p>
                          </div>
                        ) : ''
                      }
                      <Select
                        id='complain'
                        label='Motivo'
                        className='col-12 my-1'
                        displayValue='description'
                        selectedValue='idComplain'
                        options={this.props.complain || []}
                        placeholder='Selecione'
                        data-error={'Por favor, selecione o motivo.'}
                        onChange={(e) => this.selectComplain(e)}
                      />
                      <TextArea
                        id='txt-comment'
                        name='txt-comment'
                        label='Deixe um comentário'
                        className='form-field col-12 my-1'
                        childrenClassName='has-content'
                        data-error={'Por favor, deixe um comentário.'}
                        onBlur={(e) => this.commentComplain(e)}
                      />
                    </div>
                  </div>
                  <div className='col-12 py-2 px-2'>
                    <div className='row'>
                      <div className='col-12 col-md-6 my-half'>
                        <Button
                          id={'btn-back-rating'}
                          name={'btn-back-rating'}
                          className='btn btn-rating-modal col-12'
                          text='cancelar'
                          onClick={this.props.ReportToggle}
                        />
                      </div>
                      <div className='col-6 ml-md-auto ml-0'>
                        <Button
                          id={'btn-back-rating'}
                          name={'btn-back-rating'}
                          className='btn btn-featured col-12'
                          text='enviar'
                          onClick={this.onSubmit}
                          disabled={!(this.props.email && this.state.complainId && this.state.complainComment) || this.state.buttonDisabled}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

ModalReportStore.propTypes = {
  show: PropTypes.bool,
  complain: PropTypes.array,
  ReportToggle: PropTypes.func,
  toReport: PropTypes.func,
  errorReportComplain: PropTypes.bool,
  email: PropTypes.string
}

const mapStateToProps = ({ participant }, ownProps) => ({
  email: participant.email
})

export default connect(
  mapStateToProps,
  null
)(ModalReportStore)



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Store/ModalReportStore/ModalReportStore.js